import { Controller } from "@hotwired/stimulus";

// Cycles through example prompts with typing animation, looping forever
export default class extends Controller {
  static targets = ["prompt"];
  static values = { prompts: Array };

  connect() {
    this.cleanup();
    if (!this.hasPromptsValue || this.promptsValue.length === 0) return;

    this.currentIndex = 0;
    this.isRunning = true;
    this.typeNextPrompt();
  }

  disconnect() {
    this.cleanup();
  }

  cleanup() {
    this.isRunning = false;
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    if (this.hasPromptTarget) {
      this.promptTarget.textContent = "";
    }
  }

  typeNextPrompt() {
    if (!this.isRunning) return;

    const prompt = this.promptsValue[this.currentIndex];
    this.typeText(prompt).then(() => {
      if (!this.isRunning) return;

      // Pause to read, then erase
      this.timeout = setTimeout(() => {
        if (!this.isRunning) return;

        this.eraseText().then(() => {
          if (!this.isRunning) return;

          // Move to next prompt
          this.currentIndex =
            (this.currentIndex + 1) % this.promptsValue.length;
          this.timeout = setTimeout(() => this.typeNextPrompt(), 300);
        });
      }, 4000);
    });
  }

  typeText(text) {
    return new Promise((resolve) => {
      let i = 0;
      const type = () => {
        if (!this.isRunning) return resolve();
        if (i < text.length) {
          const char = text.charAt(i);
          this.promptTarget.textContent += char;
          i++;

          // Human-like variable delays
          let delay = 6 + Math.random() * 12; // Base: 6-18ms

          // Pause longer after punctuation
          if (",;:".includes(char)) delay += 30 + Math.random() * 25;
          if (".!?".includes(char)) delay += 150 + Math.random() * 100;

          // Slight pause after words
          if (char === " ") delay += Math.random() * 12;

          // Occasional longer pause (thinking)
          if (Math.random() < 0.06) delay += 80 + Math.random() * 120;

          this.timeout = setTimeout(type, delay);
        } else {
          resolve();
        }
      };
      type();
    });
  }

  eraseText() {
    return new Promise((resolve) => {
      const erase = () => {
        if (!this.isRunning) return resolve();
        const text = this.promptTarget.textContent;
        if (text.length > 0) {
          this.promptTarget.textContent = text.slice(0, -3);
          this.timeout = setTimeout(erase, 1);
        } else {
          resolve();
        }
      };
      erase();
    });
  }
}
